import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';
import { EPaymentTypeIds } from '~/src/features/payments-abn/store/actionCreators';
import { TState } from '~/src/store';

const isAbnProgramTermsEnabled = getIsAbnLoyaltyProgramEnabled();

export const selectCardPaySum = (state: TState) => {
    const { paymentData: { cardPaymentSum } } = state.payment;
    const { bonusesValue, isUseBonuses } = state.payment.paymentData;

    const bonuses = isAbnProgramTermsEnabled
        ? bonusesValue * 0.2
        : bonusesValue;

    const paySum = isUseBonuses
        ? Math.max(+(cardPaymentSum - bonuses).toFixed(2), 0)
        : cardPaymentSum;

    return paySum ? Math.ceil((paySum) * 100) / 100 : 0;
};

export const selectSeasonTicketPaySum = (state: TState) => {
    const selectedTicket = state.seasonTicketPayment.seasonTicket;
    const { isUseBonuses, amount: amountBonuses } = state.seasonTicketPayment.bonusesInfo;

    const paySum = selectedTicket?.paySum || 0;
    const bonuses = isAbnProgramTermsEnabled
        ? amountBonuses * 0.2
        : amountBonuses;

    const seasonTicketPaySum = isUseBonuses
        ? Math.max(+(paySum - bonuses).toFixed(2), 0)
        : paySum;

    return seasonTicketPaySum ? Math.ceil((seasonTicketPaySum) * 100) / 100 : 0;
};

/**
 * Возвращает сумму к списанию, за вычетом суммы бонусов
 */
export const selectPaymentSum = (state: TState): number  => {
    const { paymentTypeId } = state.payment;

    const isSeasonTicketPay = paymentTypeId === EPaymentTypeIds.WHOLESALE;

    return isSeasonTicketPay ? selectSeasonTicketPaySum(state) : selectCardPaySum(state);
};
